import { render } from "./CardGafete.vue?vue&type=template&id=1c946c49"
import script from "./CardGafete.vue?vue&type=script&lang=js"
export * from "./CardGafete.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__